import type { FC } from 'react';
import React from 'react';

import type { ModuleOrPlanActionOrgUnit } from 'src/types/orgUnit';

import DraggableOrgUnitLabel from './components/DraggableOrgUnitLabel';
import OrgUnitLabel from './components/OrgUnitLabel';

export interface OrgTreeItemProps {
  draggable?: boolean;
  orgUnit: ModuleOrPlanActionOrgUnit;
  showPriorityLabel?: boolean;
}

const OrgTreeItem: FC<OrgTreeItemProps> = ({
  draggable,
  orgUnit,
  showPriorityLabel,
}) => {
  if (!draggable)
    return <OrgUnitLabel orgUnit={orgUnit} showPriority={showPriorityLabel} />;

  return <DraggableOrgUnitLabel orgUnit={orgUnit} />;
};

export default OrgTreeItem;
